import React, {useEffect, useState} from "react";
import Header from "../../../layout/header";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import NotFoundData from "../../../../Images/no-data-found.webp"
import {toast} from "react-toastify";
import CallLogsDetails from "../CallLogsDetails";
import Camera from "react-html5-camera-photo";
import {checkSBIIssuanceRequest} from "../../../../service/FasttagToll/action";

const InactiveFse = ({
                         getInactiveFsesRequest,
                         tollById,
                         getInactiveFsesResponse = [],
                         tollView = [],
                         match,
                         getFseActivationCheckRequest,
                         getFseActivationCheckResponse = [],
                         callLogsResponse = [],
                         callLogsRequest,
                         tollPendingMeetingRequest,
                         tollPendingMeetingResponse = [],
                         documentUploadUrlPublic,
                         documentUrlDataPublic,
                         nearestPlazaFromOperatorLocationRequest,
                         nearestPlazaFromOperatorLocationResponse = [],
                         checkSBIIssuanceRequest,
                         checkSBIIssuanceResponse = []
                     }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [phoneNo, setPhoneNo] = useState(0);
    const [list, setList] = useState([]);
    const [selfie, setSelfies] = useState([])
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);
    const [isActiveScheduled, setIsActiveScheduled] = useState(false);
    let [excluding, setExcluding] = useState(0)
    const [fseLength, setFseLength] = useState(0);
    const [sbiIssuanceValidation, setSbiIssuanceValidation] = useState(false);
    const [operatorIds, setOperatorIds] = useState([]);
    const [vehicleNo, setVehicleNo] = useState('');

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            // unset all localstorage if asm, am goes to diff toll
            if(parseInt(window.localStorage.toll_id) !== parseInt(match?.params?.id)){
                delete window.localStorage.inactive_fse;
                delete window.localStorage.fse_inventory;
                delete window.localStorage.fse_tag_transfer;
                delete window.localStorage.penalty;
                delete window.localStorage.active_fse_percentage;
                delete window.localStorage.fse_inventory_percentage;
                delete window.localStorage.fse_tag_transfer_percentage;
                delete window.localStorage.penalty_percentage;
                delete window.localStorage.fse_tag_transfer_selfie;
                delete window.localStorage.penalty_selfie;
                delete window.localStorage.fse_inventory_selfie;
                delete window.localStorage.inactive_fse_selfie;
                delete window.localStorage.is_inactive_fse_tab;
                delete window.localStorage.fse_inventory_tab;
                delete window.localStorage.penalty_percentage_tab;
                delete window.localStorage.fse_tag_transfer_tab;
            }

            // window.localStorage.inactive_fse = [];
            window.localStorage.toll_id = match?.params?.id;
            window.localStorage.is_inactive_fse_tab = true;
            await tollById(match?.params?.id);
            await tollPendingMeetingRequest(match?.params?.id);
            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            if(tollView?.data?.latitude){
                await getInactiveFsesRequest(tollView?.data?.latitude, tollView?.data?.longitude, 'inactive');
            }

            setIsLoading(false);
        })();
    }, [tollView]);


    useEffect(() => {
        if(tollPendingMeetingResponse?.data && parseInt(tollPendingMeetingResponse?.data?.status)  === 1){
            // toast.warn("No meeting is scheduled on this toll");
            // setTimeout(() => {
            //     window.location.href='fast-tag-toll-list'
            // }, 1000)
            setIsActiveScheduled(true)
        }
    }, [tollPendingMeetingResponse]);

    const handleCheckActivation = async (ids, phone, i) => {
        setIsLoading(true)
        setPhoneNo(phone)
        setIndex(i)
        await getFseActivationCheckRequest(ids)
        setIsLoading(false)
    }

    useEffect(() => {
        if(getFseActivationCheckResponse?.data){
            toast.success("Fse is activated!")
            markFseActive()
            setOpen(true)
            if(!selfie[index]){
                selfie[index] = {}
            }
            selfie[index]['is_activate'] = true;
            selfie[index]['phone_no'] = phoneNo;
            setSelfies(selfie)
            window.localStorage.inactive_fse_selfie = JSON.stringify(selfie)
        } else if(getFseActivationCheckResponse?.data === false){
            toast.error("Fse is not activated!")
        }
    }, [getFseActivationCheckResponse]);

    useEffect(() => {
        console.log(getInactiveFsesResponse)
        // check operator details (FSE)
        if(getInactiveFsesResponse?.data && getInactiveFsesResponse?.data?.inactive_operator_list && getInactiveFsesResponse?.data?.inactive_operator_list.length > 0){
            // set fse operator to print
            setFseLength(getInactiveFsesResponse?.data?.inactive_operator_list.length)
            setList(getInactiveFsesResponse?.data?.inactive_operator_list)
            // check operator is set to local storage if yes then print local storage values
            if(window.localStorage.inactive_fse && JSON.parse(window.localStorage.inactive_fse).length > 0){
                setList(JSON.parse(window.localStorage.inactive_fse))
                // check selfie data in localstorage
                if(window.localStorage.inactive_fse_selfie){
                    setSelfies(JSON.parse(window.localStorage.inactive_fse_selfie))
                }
            } else {
                window.localStorage.inactive_fse = JSON.stringify(getInactiveFsesResponse?.data?.inactive_operator_list)
                window.localStorage.inactive_fse_selfie = [];
            }
        } else if(getInactiveFsesResponse?.data && getInactiveFsesResponse?.data?.inactive_operator_list && getInactiveFsesResponse?.data?.inactive_operator_list.length === 0){
            // if there is no inactive operator found then check we have marked active to any operator
            if(window.localStorage.inactive_fse){
                let inactiveUsers = JSON.parse(window.localStorage.inactive_fse);
                if(inactiveUsers && Object.keys(inactiveUsers).length > 0){
                    // set to available list to print
                    setList(inactiveUsers)
                }
            } else {
                window.localStorage.inactive_fse = [];
                window.localStorage.inactive_fse_selfie = [];
            }
        } else if(getInactiveFsesResponse?.data === undefined && !window.localStorage.inactive_fse){
            // if not operator found
            window.localStorage.inactive_fse = [];
            window.localStorage.inactive_fse_selfie = [];
        }
    }, [getInactiveFsesResponse]);

    const checkNotAtToll = async (operatorId, plazaId, phoneNo, i) => {
        // const callLogs = await CallLogsDetails();
        setIsLoading(true);
        setPhoneNo(phoneNo)
        await nearestPlazaFromOperatorLocationRequest(operatorId, plazaId);
        setIsLoading(false);
        if(!selfie[i]){
            selfie[i] = {}
        }
        selfie[i]['not_at_toll'] = true;
        selfie[i]['phone_no'] = phoneNo;
        setExcluding(excluding+1);
        window.localStorage.inactive_fse_selfie = JSON.stringify(selfie)
        setSelfies(selfie)
        // if(callLogs.length > 0){
        //     let data = {call_log: callLogs, fse_phone_no: phoneNo}
        //     setIsLoading(true)
        //     await callLogsRequest(data)
        //     setIsLoading(false)
        // } else {
        //     toast.error("Need permission for call or you haven't not connected with fse!")
        // }
    }

    // const checkNotAtToll = async (phoneNo) => {
    //     const callLogs = await CallLogsDetails();
    //     console.log("response of call log", callLogs)
    //     if(callLogs.length > 0){
    //         let data = {call_log: callLogs, fse_phone_no: phoneNo}
    //         setIsLoading(true)
    //         setPhoneNo(phoneNo)
    //         await callLogsRequest(data)
    //         setIsLoading(false)
    //     } else {
    //         toast.error("Need permission for call or you haven't not connected with fse!")
    //     }
    // }

    useEffect(() => {
        // check call logs
        if(parseInt(callLogsResponse?.status) === 200){
            markFseActive()
            toast.success("Action is saved!")
        } else if(parseInt(callLogsResponse?.status) !== 200){
            toast.error(callLogsResponse?.message)
        }
    }, [callLogsResponse]);

    useEffect(() => {
        // check call logs
        if(parseInt(nearestPlazaFromOperatorLocationResponse?.status) === 200){
            markFseActive(phoneNo, false)
            excluding++;
            setTimeout(() => {
                setExcluding(excluding);
            }, 1000)
            toast.success("Action is saved!")
        } else if(parseInt(nearestPlazaFromOperatorLocationResponse?.status) !== 200){
            toast.error(nearestPlazaFromOperatorLocationResponse?.message)
        }
    }, [nearestPlazaFromOperatorLocationResponse]);


    const markFseActive = (phone_no = '', notPercantage = true) => {
        let activeFse = JSON.parse(window.localStorage.inactive_fse);
        let count = 0;
        let phone = phone_no ? phone_no : phoneNo;
        if(activeFse){
            // mark asm, am take action
            activeFse.map((val, i) => {
                if(parseInt(val?.user_phone) === parseInt(phone)){
                    activeFse[i]['is_active'] = true;
                }

                if(val?.is_active){
                    count++;
                }
            });
            window.localStorage.inactive_fse = JSON.stringify(activeFse);
            // if(notPercantage){
            //     window.localStorage.active_fse_percentage = (count  * 100) / activeFse.length;
            // }
            window.localStorage.active_fse_percentage = (count  * 100) / activeFse.length;
            // console.log("excluding", excluding)
            if(excluding === activeFse.length){
                window.localStorage.active_fse_percentage = 100
            }
            window.location.reload();
        }
    }

    const handleCloseConfirmationModal = () => setOpen(false);
    const handleOpenConfirmationModal = (index, phone_no) => {
        setOpen(true)
        setIndex(index)
        setPhoneNo(phone_no)
    }

    const handleCloseVehicleNoModal = () => {
        setVehicleNo('');
        setSbiIssuanceValidation(false);
        setOperatorIds([]);
        phoneNo('');
        setIndex('');
    };

    useEffect(() => {
        if (documentUrlDataPublic?.file_url) {
            if(!selfie[index]){
                selfie[index] = {}
            }

            selfie[index]['selfie'] = documentUrlDataPublic?.file_url;
            selfie[index]['phone_no'] = phoneNo;
            setSelfies(selfie)
            window.localStorage.inactive_fse_selfie = JSON.stringify(selfie)
        }
    }, [documentUrlDataPublic]);

    const notMyFse = (phoneNo, i) => {
        setIsLoading(true);
        if(!selfie[i]){
            selfie[i] = {}
        }

        selfie[i]['not_my_fse'] = true;
        selfie[i]['phone_no'] = phoneNo;
        setSelfies(selfie)
        toast.success("Successfully marked");
        markFseActive(phoneNo, false)
        window.localStorage.inactive_fse_selfie = JSON.stringify(selfie)
        setIsLoading(false);
    }

    const handleCheckSBIIssuance = async () => {
        setIsLoading(true)
        await checkSBIIssuanceRequest(vehicleNo)
        setIsLoading(false)
    }

    useEffect(() => {
        if(checkSBIIssuanceResponse?.data){
            toast.success("SBI tag is activated!")
            markFseActive(phoneNo, false)
            if(!selfie[index]){
                selfie[index] = {}
            }
            selfie[index]['is_sbi_issuance'] = true;
            selfie[index]['phone_no'] = phoneNo;
            selfie[index]['vehicle_no'] = vehicleNo;
            setSelfies(selfie);
            setOperatorIds([]);
            setSbiIssuanceValidation(false);
            setVehicleNo('');
            window.localStorage.inactive_fse_selfie = JSON.stringify(selfie)
        } else if(checkSBIIssuanceResponse?.data === false){
            toast.error("SBI tag is not activated!")
        }
    }, [checkSBIIssuanceResponse]);

    return (
        <>
            <Loader isLoading={isLoading}/>
            {open &&
                <>
                    <div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog"
                         aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLongTitle">Selfie</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" onClick={() => {handleCloseConfirmationModal()}}>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {selfie[index]?.selfie ?
                                        <img alt="selfie"
                                             src={selfie[index]}/>
                                        :
                                        <Camera
                                            idealFacingMode={'user'}
                                            idealResolution={{
                                                width: 600,
                                                height: 480
                                            }}
                                            onTakePhoto={(dataUri) => {
                                                (async () => {
                                                    setIsLoading(true)
                                                    await documentUploadUrlPublic({ base_64_file: dataUri })
                                                    setIsLoading(false)
                                                })()
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }

            {sbiIssuanceValidation &&
                <>
                    <div className="modal fade" id="sbiIssuanceValidation" tabIndex="-1" role="dialog"
                         aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLongTitle">SBI Issuance</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" onClick={() => {setSbiIssuanceValidation(false)}}>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="col-md-12 float-field ">
                                        <input
                                            type="text"
                                            className="form-control form-control-user"
                                            onChange={(e) => {setVehicleNo(e.target.value)}}
                                        />
                                        <label className="large-label float-lb">
                                            Vehicle No:<i className=""></i>
                                        </label>
                                    </div>
                                    <div className="col-md-12 float-field ">
                                        <button
                                            className="btn btn-primary mt-2 text-center"
                                            style={{width: "100%"}}
                                            data-target="#sbiIssuanceValidation"
                                            data-toggle="modal"
                                            onClick={() => {
                                                handleCheckSBIIssuance()
                                            }}
                                        >Validate
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header title={"Inactive FSE"}/>
                        {/*BODY*/}
                        <div className="container-fluid common-bg">
                            {list.length > 0 && list.map((val, i) => {
                                return (
                                    <>
                                        <div className="card">
                                            <div className="card-header" style={{
                                                backgroundColor: "#473381",
                                                color: "white"
                                            }}>{val?.user_name}</div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="mb-0 bg-white">
                                                        <div className="card-body">
                                                            <div className="user">
                                                                <div className="row">
                                                                    <div className="col-md-12 float-field ">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-user"
                                                                            value={
                                                                                val?.user_phone
                                                                            }
                                                                        />
                                                                        <label className="large-label float-lb">
                                                                            Phone No:<i className=""></i>
                                                                        </label>
                                                                    </div>

                                                                    {isActiveScheduled &&
                                                                        <>
                                                                            <div className="col-md-12 float-field ">
                                                                                <button
                                                                                    className={`${val?.is_active ? "btn btn-success" : "btn btn-primary"}`}
                                                                                    style={{width: "100%"}}
                                                                                    onClick={() => {
                                                                                        handleCheckActivation(val?.operator_id_list, val?.user_phone, i)
                                                                                    }}
                                                                                    disabled={val?.is_active}
                                                                                >Check Activation
                                                                                </button>
                                                                            </div>
                                                                            {selfie[i]?.selfie ?
                                                                                <div
                                                                                    className="col-md-12 float-field mt-2">
                                                                                    <a href={selfie[i]?.selfie}
                                                                                       target="_blank"
                                                                                       className="btn btn-info"
                                                                                       style={{width: "100%"}}
                                                                                       data-dismiss="modal"
                                                                                       aria-label="Close">Selfie</a>
                                                                                </div>
                                                                                :
                                                                                <div
                                                                                    className="col-md-12 float-field mt-2">
                                                                                    <button
                                                                                        className="btn btn-primary"
                                                                                        data-toggle="modal"
                                                                                        data-target="#exampleModalCenter"
                                                                                        style={{width: "100%"}}
                                                                                        onClick={() => {
                                                                                            handleOpenConfirmationModal(i, val?.user_phone)
                                                                                        }}
                                                                                    >Selfie
                                                                                    </button>
                                                                                </div>
                                                                            }

                                                                            <div className="col-md-12 float-field ">
                                                                                <button
                                                                                    className="btn btn-primary mt-2 text-center"
                                                                                    style={{width: "100%"}}
                                                                                    onClick={() => {
                                                                                        checkNotAtToll(val?.operator_id_list[0], getInactiveFsesResponse?.data?.plaza_id, val?.user_phone, i)
                                                                                        // checkNotAtToll(val?.user_phone)
                                                                                    }}
                                                                                    disabled={val?.is_active}>Check FSE
                                                                                    Not at
                                                                                    Toll
                                                                                </button>
                                                                            </div>
                                                                            <div className="col-md-12 float-field ">
                                                                                <button
                                                                                    className="btn btn-primary mt-2 text-center"
                                                                                    style={{width: "100%"}}
                                                                                    onClick={() => {
                                                                                        notMyFse(val?.user_phone, i)
                                                                                    }}
                                                                                    disabled={val?.is_active}
                                                                                >Not My FSE
                                                                                </button>
                                                                            </div>
                                                                            <div className="col-md-12 float-field ">
                                                                                <button
                                                                                    className="btn btn-primary mt-2 text-center"
                                                                                    style={{width: "100%"}}
                                                                                    data-target="#sbiIssuanceValidation"
                                                                                    data-toggle="modal"
                                                                                    onClick={() => {
                                                                                        setOperatorIds(val?.operator_id_list)
                                                                                        setSbiIssuanceValidation(true)
                                                                                        setPhoneNo(val?.user_phone)
                                                                                        setIndex(i)
                                                                                    }}
                                                                                    disabled={val?.is_active}
                                                                                >Check For SBI Issuance
                                                                                </button>
                                                                            </div>
                                                                        </>
                                                                    }

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            })}

                            {list.length === 0 &&
                                <>
                                    <img src={NotFoundData} className="not-found-data" alt={""}/>
                                    <p className="text-center">Operator not found</p>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
};
export default InactiveFse;
